import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "./FilterGroups.scss";
const SkeletonFilters = () => {
  const FilterList = [{ id: 1 }, { id: 2 }];
  const { t } = useTranslation();
  return (
    <>
      <div className="job-search-filters ">
        <h4 className="xs-heading">
          <span>
            <Skeleton width={250} />
          </span>
          <span className="toggle-filters ">
            <i></i>
            {t("show_filters")}
          </span>
        </h4>
        {FilterList.map((item) => (
          <div className="filter-group open-filters" key={item.id}>
            <div className="filter-heading">
              <Skeleton width={250} />
            </div>
            <div className="filters">
              <div className="filter">
                <div className="element checkbox form-group">
                  <div className="field">
                    <div className="icheck-primary">
                      <input />
                      <label htmlFor="">
                        <Skeleton width={150} />
                      </label>
                    </div>
                  </div>
                </div>
                <div className="element checkbox form-group">
                  <div className="field">
                    <div className="icheck-primary">
                      <input />
                      <label htmlFor="">
                        <Skeleton width={120} />
                      </label>
                    </div>
                  </div>
                </div>
                <div className="element checkbox form-group">
                  <div className="field">
                    <div className="icheck-primary">
                      <input />
                      <label htmlFor="">
                        <Skeleton width={100} />
                      </label>
                    </div>
                  </div>
                </div>
                <div className="element checkbox form-group">
                  <div className="field">
                    <div className="icheck-primary">
                      <input />
                      <label htmlFor="">
                        <Skeleton width={80} />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default SkeletonFilters;
